import { render } from "./DADataTableLazy2 copy.vue?vue&type=template&id=49b8c39f"
import script from "./DADataTableLazy2 copy.vue?vue&type=script&lang=js"
export * from "./DADataTableLazy2 copy.vue?vue&type=script&lang=js"

import "./DADataTableLazy2 copy.vue?vue&type=style&index=0&id=49b8c39f&lang=scss"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__